export enum SuklFileType {
    Dis13 = "DIS13",
    Req13 = "REG13",
}
